import { Button, Drawer, Skeleton, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { buildSearchQuery, colors } from "../Utils/Index";
import { OrderStatus } from "../Constants/Constants";
import { fetchOrders, updateOrderStatus } from "../ApiService/Apis/order/order";
import { triggerSnackbar } from "../Services/NotificationService";
import { getNotifications } from "../ApiService/Apis/Dashboard/Dash";
import { MdCancel } from "react-icons/md";

const NotificationDrawer = ({ open, setOpen }) => {
  const [selectedStatus, setSelectedStatus] = useState({
    main: null,
    submain: null,
    btnLoading: false,
  });
  const [neworderlist, setNewOrderList] = useState([]);
  const [loader, setloader] = useState(false);
  const [current, setcurrent] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const getAllOrders = (set=false) => {
    setloader(true);
    const params = {
      page: !set?current:1,
    };
    getNotifications(buildSearchQuery(params))
      .then((res) => {
        if (res.status) {
          setNewOrderList(!set?[...neworderlist,...res.data]:res.data);
          setHasMore(res.pagination?.nextPage);

        }
      })
      .catch((err) => console.log(err))
      .finally(() => setloader(false));
  };
  const updateOrderStatuses = (id, status) => {
    setSpinner(true);
    updateOrderStatus(
      {
        status: status,
      },
      `/${id}`
    )
      .then((res) => {
        if (res.status) {
          getAllOrders(true);
          triggerSnackbar(res.message, "success");
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setSpinner(false));
  };
  useEffect(() => {
    getAllOrders();
    //eslint-disable-next-line
  }, [current]);
  return (
    <>
      <Drawer
        closable={false}
        width={400}
        open={open}
        placement="right"
        className="text-dynmaicText"
        onClose={() => setOpen(false)}
      >
          <div
          onClick={() => setOpen(false)}
          className="flex lg:hidden justify-end items-center"
        >
          <MdCancel size={25} color={colors.red} />
        </div>
        <p className="font-bold text-2xl">Notifications</p>
        <div className="w-1/4 mt-2 bg-brand h-[2px]"></div>

        {loader ? (
          <Skeleton active />
        ) : neworderlist?.length > 0 ? (
          <>
            <div className="max-h-[83%] overflow-scroll">
              <Spin spinning={spinner}>
                {neworderlist.map((i, index1) => {
                  return (
                    <div key={index1} className="bg-darkbg2 my-4 p-4">
                      <div className="flex justify-between items-center">
                        <p className="text-sm font-semibold">
                          Order Number: {i.id}
                        </p>
                        <p className="text-sm font-semibold">
                          Table Number: {i?.table?.table_no}
                        </p>
                      </div>
                      <div className="grid grid-cols-3 place-items-center gap-3 mt-4">
                        {OrderStatus?.filter(
                          (i) => i.key != "waiting_for_confirmation"
                        )?.map((i, index2) => {
                          return (
                            <p
                              onClick={() =>
                                setSelectedStatus({
                                  main: index1,
                                  submain: index2,
                                })
                              }
                              key={index2}
                              className={` ${
                                selectedStatus.main === index1 &&
                                selectedStatus?.submain === index2
                                  ? "bg-brand"
                                  : "border border-green-500"
                              } text-center px-4 py-2 cursor-pointer w-full`}
                            >
                              {i.label}
                            </p>
                          );
                        })}
                      </div>
                      <div className="flex justify-end mt-2 items-center">
                        <Button
                          disabled={Object.values(selectedStatus).some(
                            (i) => i == null
                          )}
                          onClick={() => {
                            updateOrderStatuses(
                              i.id,
                              OrderStatus[selectedStatus?.submain]["key"]
                            );
                          }}
                          style={{ background: colors.red, color: "white" }}
                          className="rounded-none bg-red-500 font-inter border-none text-dynmaicText"
                        >
                          Submit
                        </Button>
                      </div>
                      <div></div>
                    </div>
                  );
                })}
              </Spin>
            </div>
            {hasMore && (
              <div className="flex justify-center items-center mt-2">
                <Button
                  onClick={() => setcurrent(current + 1)}
                  loading={spinner}
                  style={{ background: colors.green, color: "white" }}
                  className="rounded-none border-none font-inter text-dynmaicText"
                >
                  Load More
                </Button>
              </div>
            )}
          </>
        ) : (
          <p className="text-dynmaicText font-bold font-inter text-center mt-20">
            No New Orders
          </p>
        )}
      </Drawer>
    </>
  );
};

export default NotificationDrawer;
